export default function AboutSection() {
  return (
    <section id="about" className="relative py-20 md:py-28 bg-background-950">
      <div className="section-padding max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center reveal">
          {/* Text Content */}
          <div className="order-2 lg:order-1">
            <p className="text-primary-400 text-xs font-semibold tracking-[0.25em] uppercase mb-4">
              About Avenor Meridian
            </p>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-50 mb-6 leading-tight">
              Reliable Procurement
              <br />
              for Heavy Industry
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-400 leading-relaxed mb-8">
              <p>
                <strong className="text-foreground-200">Avenor Meridian</strong> is not tied to one brand or one supply chain. That independence gives us more options — especially when lead times stretch, parts are discontinued, or availability is limited.
              </p>
              <p>
                We combine global supplier reach with disciplined verification, so clients get consistent quality, documentation, and long-term value — not surprises.
              </p>
              <p>
                Founded with deep roots in industrial procurement, we have supported major mining operations, marine fleets, construction projects, and power plants worldwide.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 pt-6 border-t border-background-800/50">
              <div>
                <p className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">15+</p>
                <p className="text-xs text-foreground-500 mt-1">Countries Served</p>
              </div>
              <div>
                <p className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">100+</p>
                <p className="text-xs text-foreground-500 mt-1">Manufacturers</p>
              </div>
              <div>
                <p className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">4</p>
                <p className="text-xs text-foreground-500 mt-1">Core Industries</p>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Industrial%20warehouse%20interior%20with%20rows%20of%20heavy%20machinery%20spare%20parts%20on%20shelves%2C%20organized%20steel%20components%2C%20dark%20dramatic%20lighting%2C%20professional%20industrial%20photography%2C%20metallic%20textures%2C%20high%20contrast&width=800&height=600&seq=about-01&orientation=landscape"
                alt="Industrial spare parts warehouse"
                className="w-full h-72 md:h-96 object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 to-transparent"></div>

              {/* Floating badge */}
              <div className="absolute bottom-6 left-6 right-6 bg-background-950/80 backdrop-blur-sm border border-background-800/50 rounded-lg p-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-500/10 border border-primary-500/20 rounded-lg shrink-0">
                    <i className="ri-global-line text-primary-400"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-100">Global Sourcing Network</p>
                    <p className="text-xs text-foreground-500">Direct access to OEM and aftermarket suppliers</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}